import { render, staticRenderFns } from "./TheoryPracticeWorkshopLessonPractices.vue?vue&type=template&id=7593336a&scoped=true&"
import script from "./TheoryPracticeWorkshopLessonPractices.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeWorkshopLessonPractices.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeWorkshopLessonPractices.vue?vue&type=style&index=0&id=7593336a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7593336a",
  null
  
)

export default component.exports